<template>
<area-component
  :ad="Array.isArray(ad) ? {} : ad"
  :show-skeleton="showSkeleton"
  v-model="isLoading"
  @onRefresh="onRefresh"
  @loadData="loadData"
  :errorImg="require(`@/assets/img/home/activity_banner.jpg`)"
  title="活动专区"
  ref="areaComponent">
  <div class="goods-list">
    <not-goods v-if="list.length === 0"></not-goods>
    <goods-item
      v-for="item in list"
      :item="item"
      :key="item.id"
      @click.native="toDetail(item)"
      :stockTag="getShowStock (item)"
    >
      <template slot="btn">
        <goods-btn
          :btn-type="getGoodsType(item)"
          @openCart="openCart(item)"
        />
      </template>
    </goods-item>
  </div>
  <!-- 购物车弹窗start(有库存) -->
    <cc-shop-cart
      :isShowPopup="showcart"
      :cartItemData="cartItem"
      @close="showcart=false"
      getContainer="body"
      :height="556"
      :HeaderHight="88"
      ref="shopCart"
    ></cc-shop-cart>
  <!-- 购物车弹窗end -->
  <!-- 缺货弹窗start-->
    <cc-nogoods-remind
      :isShowPopup="shownogoods"
      :cartItem="cartItem"
      getContainer="body"
      :height="426"
      @close="shownogoods=false"
      ref="nogoods"
    ></cc-nogoods-remind>
</area-component>
</template>

<script>
import AreaComponent from '../components/area-component'
import GoodsItem from '../components/item-component'
import CommandMixin from '@/mixins/command'
import GoodsBtn from '../components/btn'
import CartStepMixin from '@/mixins/cartStep'
import NotGoods from '../components/not-goods'
import { requestActivitylist } from '../../../fetch/home/activity'
export default {
  name: 'activity',
  mixins: [CommandMixin, CartStepMixin],
  components: { GoodsItem, AreaComponent, GoodsBtn, NotGoods },
  data () {
    return {
      list: [],
      isLoading: false,
      showSkeleton: true,
      ad: null
    }
  },
  created () {
    this.$nextTick(() => {
      this.loadData()
    })
  },
  computed: {
    areaComponent () {
      return this.$refs.areaComponent
    },
    getShowStock () {
      return function (item) {
        if (this.getLoginStatus.data.member_id && item.goodsstock * 1 <= 0 && this.getLoadSettingStatus.data.is_empty_stock === 0) {
          return 2
        } else {
          return 1
        }
      }
    }
  },
  methods: {
    toDetail (item) {
      this.$router.push({
        path: '/goods-details',
        query: {
          goods_id: item.id,
          type: item.for_type
        }
      })
    },
    getGoodsType (item) {
      if (item.userid) { // 登录
        if (item.is_view === 1 || (item.is_bargain === 1 && item.tag === 2)) { // 区域经销 或者议价商品
          return 1
        }
        // if (item.hidestock * 1 === 0) { // 无特价库存
        //   return 3
        // }
        if (item.goodsstock * 1 <= 0 && this.getLoadSettingStatus.data.is_empty_stock === 0) { // 无商品库存 并且0库存不允许购买
          return 4
        }
        return 2
      } else {
        return 0
      }
    },
    openCart (item) {
      this.cartBtnAlter(item, this.cartIconColor(item) ? 1 : 0)
    },
    onRefresh () {
      this.areaComponent.mReset()
      this.loadData(true)
    },
    async loadData (reset) {
      const params = {
        page: this.areaComponent.m_page.curr,
        limit: this.areaComponent.m_page.limit
      }
      const res = await requestActivitylist(params)
      this.$tips(res, {
        tip: false
      }, res => {
        if (this.showSkeleton) {
          this.showSkeleton = false
        }
        this.isLoading = false
        const data = res
        this.ad = data.ad
        if (data.activity_goods_arr.length === 0) {
          this.areaComponent.mEnd('--我也是有底线的--')
          if (reset) {
            this.list = []
          }
          if (this.list.length === 0) {
            this.areaComponent.m_finishedText = ''
          }
        } else {
          if (reset) {
            this.list = data.activity_goods_arr
          } else {
            this.list.push(...data.activity_goods_arr)
          }
          this.addGoodField(this.list)
        }
        this.areaComponent.mSuccess()
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
